import fallingStarWhite from './files/behaviors/falling_star_white.svg';
import fallingStarGrey from './files/behaviors/falling_star_grey.svg';
import flatGrey from './files/behaviors/flat_grey.svg';
import flatWhite from './files/behaviors/flat_white.svg';
import risingStarGrey from './files/behaviors/rising_star_grey.svg';
import risingStarWhite from './files/behaviors/rising_star_white.svg';
import seasonalDeclinerGrey from './files/behaviors/seasonal_decliner_grey.svg';
import seasonalDeclinerWhite from './files/behaviors/seasonal_decliner_white.svg';
import seasonalRiserGrey from './files/behaviors/seasonal_riser_grey.svg';
import seasonalRiserWhite from './files/behaviors/seasonal_riser_white.svg';
import sustainedDeclinerGrey from './files/behaviors/sustained_decliner_grey.svg';
import sustainedDeclinerWhite from './files/behaviors/sustained_decliner_white.svg';
import sustainedRiserGrey from './files/behaviors/sustained_riser_grey.svg';
import sustainedRiserWhite from './files/behaviors/sustained_riser_white.svg';
import seasonalFlatGrey from './files/behaviors/seasonal_flat_grey.svg';
import seasonalFlatWhite from './files/behaviors/seasonal_flat_white.svg';

export default {
  fallingStarWhite,
  fallingStarGrey,
  flatGrey,
  flatWhite,
  risingStarGrey,
  risingStarWhite,
  seasonalDeclinerGrey,
  seasonalDeclinerWhite,
  seasonalRiserGrey,
  seasonalRiserWhite,
  sustainedDeclinerGrey,
  sustainedDeclinerWhite,
  sustainedRiserGrey,
  sustainedRiserWhite,
  seasonalFlatGrey,
  seasonalFlatWhite,
};
